@if (isMenuLoaded) {
  <nav class="sidebar" [class.sidebar--collapsed]="isCollapsed">
    <lwty-button-icon
      class="sidebar__toggle"
      theme="minimal"
      [icon]="'menu'"
      [attr.aria-label]="'Navigation.ToggleMenu' | translate"
      (click)="toggleMenu()" />
    @if (navItems) {
      <ul class="sidebar__sections">
        @for (item of navItems; track item.displayName ?? item) {
          <li class="sidebar__sections__section">
            @if (item.displayName) {
              <p class="sidebar__sections__section__title">
                {{
                  this.isCollapsed && item?.displayCollapsedName
                    ? (item.displayCollapsedName ?? "" | translate)
                    : (item?.displayName ?? "" | translate)
                }}
              </p>
            }
            @if (item.children) {
              <ul class="sidebar__sections__section__routes">
                @for (
                  children of item.children;
                  track children.displayName ?? children
                ) {
                  <li
                    class="sidebar__sections__section__routes__item"
                    routerLinkActive="active">
                    @if (getNavItemUrl(children); as url) {
                      <a
                        [attr.data-testid]="
                          getDataTestId(children.displayName ?? '')
                        "
                        [routerLink]="url.params"
                        [queryParams]="url.queryParams">
                        <icon-display
                          class="sidebar__sections__section__routes__item__icon"
                          [height]="24"
                          [width]="24"
                          [iconName]="children.iconName" />
                        <span>{{
                          this.isCollapsed && children?.displayCollapsedName
                            ? (children.displayCollapsedName ?? "" | translate)
                            : (children?.displayName ?? "" | translate)
                        }}</span>
                        @if (children?.count && !this.isCollapsed) {
                          <app-pill
                            class="sidebar__sections__section__routes__item__count"
                            [theme]="'blue'"
                            [count]="children.count ?? 0" />
                        }
                      </a>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    }
  </nav>
}
